module.exports = __webpack_public_path__ + "img/logo_pital.5cf3d1c8.png";